import React, { useEffect, useState } from 'react';

/**
 * Render children only in the browser (skips SSR/SSG hooks that need window).
 *
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {React.ReactNode} [props.fallback]
 * @returns {React.ReactNode}
 */
export function ClientOnly({ children, fallback = null }) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return fallback;
  }

  return children;
}
